export const projects = [
  
  {
    title: "Excel-to-HTML Converter",
    subtitle: "JavaScript, Tailwind CSS, SheetJS, U.S. Web Design System",
    description: "Converts Excel spreadsheets into clean, copyable HTML tables — with selectable formatting options and instant preview.",
    image: "./assets/excel-to-html-converter-screenshot.png",
    repo: "https://github.com/evperkinsjr/excel-to-html-converter",
    link: "https://evperkinsjr.github.io/excel-to-html-converter/",
  },
  {
    title: "Google Books Search",
    subtitle: "MERN Stack, Google Books API, JavaScript, Bootstrap, Heroku",
    description: "Full-stack application lets users search the Google Books API for books of interest.",
    image: "./assets/google-books-search-screenshot.png",
    repo: "https://github.com/evperkinsjr/google-books-search",
    link: "https://salty-sands-65360.herokuapp.com/",
  },
  {
    title: "React Employee Directory",
    subtitle: "React, Bootstrap, JavaScript, Node.js, Random User API",
    description: "Users can view names, photos, and contact information of everyone in the company.",
    image: "./assets/react-employee-directory-screenshot.png",
    repo: "https://github.com/evperkinsjr/react-employee-directory",
    link: "https://evperkinsjr.github.io/react-employee-directory/",
  },
  {
    title: "Movie-Drink Matchmaker",
    subtitle: "HTML, CSS, JavaScript, Bulma (CSS Framework), jQuery, APIs",
    description: "Date night application that provides the user with a movie and drink recommendation based on their selections.",
    image: "./assets/movie-drink-matchmaker-screenshot.png",
    repo: "https://github.com/evperkinsjr/movie-drink-matchmaker",
    link: "https://evperkinsjr.github.io/movie-drink-matchmaker/",
  }
];

export const testimonials = [
  {
    quote: "",
    image: "",
    name: "",
    company: "",
  },
  {
    quote: "",
    image: "",
    name: "",
    company: "",
  },
];

export const skills = [
  "JavaScript",
  "HTML / CSS",
  "MongoDB",
  "Express",
  "React",
  "Node",
  "MySQL",
  "Python",
  "Flask",
  "Heroku"
];


// WEBPACK FOOTER //
// ./src/data.js